import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React from 'react';

import styles from './styles';

interface IRadioSelectionProps {
  formLabel: string;
  options: {
    value: string;
    label: string;
  }[];
  selectedValue: string;
  handleSelected: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void;
  isDisabled: boolean;
}

function RadioSelection({ formLabel, options, selectedValue, handleSelected, isDisabled }: IRadioSelectionProps) {
  const classes = styles();

  return (
    <FormControl className={classes.formControl}>
      <FormLabel className={classes.boxSubtitle}>
        <p>{formLabel}</p>
      </FormLabel>
      <RadioGroup className={classes.optionsGroup} value={selectedValue} onChange={handleSelected}>
        {options.map((option) => (
          <FormControlLabel
            className={`${classes.options} ${option.value === selectedValue && !isDisabled ? '--selected' : ''} ${isDisabled ? '--disabled' : ''}`}
            key={option.value}
            id={`radio-option-${option.value}`}
            control={<Radio />}
            value={option.value}
            label={option.label}
            disabled={isDisabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioSelection;
